import { BreadHeight, BreadOpen, G_HeaderHeight } from '@/config/theme';
import { useSize } from 'ahooks';
import { useState, useEffect, useMemo } from 'react';

function useScreenHeight() {
    const bodySize = useSize(document.querySelector('body'));
    const [height, setHeight] = useState<number>(0);
    const calculateHeight = () => {
        const navHeight = 64;  // 假设导航栏高度为64px
        const margin = 16 * 2; // 上下各有16px的间距
        const bread = BreadOpen ? BreadHeight : 0;  // 根据面包屑是否展开来决定高度
        const newHeight = window.innerHeight - navHeight - margin - bread;
        setHeight(newHeight);
    };

    useEffect(() => {
        calculateHeight()
    }, [bodySize.height])

    return { height: height, innerHeight: bodySize.height,innerWidth: bodySize.width }

}

export default useScreenHeight;

